import { IconProps } from './type';

const IconChevronUp = ({ ...svgProps }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...svgProps}
    >
      <path
        d="M4.14708 12.3542C3.95147 12.1593 3.9509 11.8427 4.14582 11.6471L9.6108 6.16258C9.82574 5.94686 10.1751 5.94687 10.39 6.16258L15.855 11.6471C16.0499 11.8427 16.0493 12.1593 15.8537 12.3542C15.6581 12.5491 15.3415 12.5485 15.1466 12.3529L10.0004 7.18833L4.85418 12.3529C4.65927 12.5485 4.34269 12.5491 4.14708 12.3542Z"
        fill="#333333"
      />
    </svg>
  );
};

export default IconChevronUp;
